import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DirectivesModule } from '../../../../directives/directives.module';
import { PipesModule } from '../../../../pipes/pipes.module';
import { SharedModule } from '../../../shared/shared.module';

import { RankingsMainFilterItemsComponent } from '../rankings-main-filter-items/rankings-main-filter-items.component';

import { AppIdOnlyComponent } from './app-id-only.component';
import { AppNameComponent } from './app-name.component';
import { AppNameOnlyComponent } from './app-name-only.component';
import { BigNumberDataComponent } from './big-number-data.component';
import { CoppaAudienceComponent } from './coppa-audience.component';
import { CountryComponent } from './country.component';
import { DataOnlyComponent } from './data-only.component';
import { DeveloperNameComponent } from './developer-name.component';
import { DollarCurrencyDataComponent } from './dollar-currency-data.component';
import { DomainNameComponent } from './domain-name.component';
import { GridHeaderComponent } from './grid-header.component';
import { GridHeaderContainerComponent } from './grid-header-container.component';
import { GridHeaderWithPopoverComponent } from './grid-header-with-popover.component';
import { GridHeaderWithPopoverSearchComponent } from './grid-header-with-popover-search.component';
import { GridHeaderWithTooltipComponent } from './grid-header-with-tooltip.component';
import { OsNameComponent } from './os-name.component';
import { PercentDataComponent } from './percent-data.component';
import { ProgramTitleComponent } from './program-title.component';
import { PublisherNameComponent } from './publisher-name.component';
import { RankDataComponent } from './rank-data.component';
import { RankGradeComponent } from './rank-grade.component';
import { RatingBarComponent } from './rating-bar.component';
import { RatingBarV2Component } from './rating-bar-v2.component';
import { RatingPillComponent } from './rating-pill.component';
import { RatingSignalComponent } from './rating-signal.component';
import { RiskPillOnlyComponent } from './risk-pill-only.component';
import { SellerNameComponent } from './seller-name.component';
import { SellerRegionComponent } from './seller-region.component';
import { WidgetContainerComponent } from './widget-container.component';
import { YesnoComponent } from './yesno.component';
import { SellerNameWithBadgeComponent } from './seller-name-with-badge.component';
import { SellerRiskComponent } from './seller-risks.component';
import { PercentDataWithZeroComponent } from './percent-data-with-zero.component';
import { DataTimeOfDayComponent } from './data-time-of-day.component';
import { DMAComponent } from './dma-only.component';
import { SdkNameComponent } from './sdk-name.component';
import { SdkViolationRiskComponent } from './sdk-violation-risk.component';
import { RankingsSearchFilterComponent } from '../rankings-search-filter/rankings-search-filter.component';
import { SdkCodeAnalysisRiskComponent } from './sdk-code-analysis-risk.component';

@NgModule({
  declarations: [
    AppIdOnlyComponent,
    AppNameComponent,
    AppNameOnlyComponent,
    BigNumberDataComponent,
    CoppaAudienceComponent,
    CountryComponent,
    DataOnlyComponent,
    DataTimeOfDayComponent,
    DMAComponent,
    DeveloperNameComponent,
    DollarCurrencyDataComponent,
    DomainNameComponent,
    GridHeaderComponent,
    GridHeaderContainerComponent,
    GridHeaderWithPopoverComponent,
    GridHeaderWithPopoverSearchComponent,
    GridHeaderWithTooltipComponent,
    OsNameComponent,
    PercentDataComponent,
    PercentDataWithZeroComponent,
    ProgramTitleComponent,
    PublisherNameComponent,
    RankDataComponent,
    RankGradeComponent,
    RankingsMainFilterItemsComponent,
    RankingsSearchFilterComponent,
    RatingBarComponent,
    RatingBarV2Component,
    RatingPillComponent,
    RatingSignalComponent,
    RiskPillOnlyComponent,
    SdkNameComponent,
    SdkViolationRiskComponent,
    SdkCodeAnalysisRiskComponent,
    SellerNameComponent,
    SellerNameWithBadgeComponent,
    SellerRiskComponent,
    SellerRegionComponent,
    WidgetContainerComponent,
    YesnoComponent
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule,
    PipesModule,
    RouterModule,
    SharedModule
  ],
  exports: [
    GridHeaderContainerComponent,
    RankingsMainFilterItemsComponent,
    RankingsSearchFilterComponent,
    WidgetContainerComponent
  ],
  providers: []
})
export class DataWidgetsModule {}
